export function loadView(name) {
    return () => import(/* webpackChunkName: "[request]" */ `@/views/${name}`).then((m) => m.default);
}
